export const getPredictions = (state) => state.autocomplete.predictions
export const isMenuOpen = (state) => state.autocomplete.menuIsOpen
export const getSelectedPredictionIndex = (state) =>
  state.autocomplete.selectedPredictionIndex
